import { useSyncExternalStore } from 'react';
export default class ItemStore {
    eventTarget = new EventTarget();
    items = [];
    register(id, data) {
        const foundItem = this.items.find(t => t.id === id);
        if (foundItem)
            return foundItem;
        const item = {
            ...data,
            id,
            patch: (patch, emitChange = true) => {
                const newItems = this.items.map(t => t.id === id ? { ...t, ...patch } : t);
                this.items = newItems;
                if (emitChange)
                    this.emitChanges(id);
            },
        };
        this.items.push(item);
        this.emitChanges(id);
        return item;
    }
    emitChanges(id) {
        setTimeout(() => {
            this.eventTarget.dispatchEvent(new CustomEvent('change', { detail: id }));
            this.eventTarget.dispatchEvent(new CustomEvent(`change-${id}`, { detail: id }));
        }, 10);
    }
    unregister(id) {
        this.items = this.items.filter(t => t.id !== id);
        this.emitChanges(id);
    }
    unregisterAll() {
        const ids = this.items.map(t => t.id);
        this.items = [];
        ids.forEach(id => this.emitChanges(id));
    }
    subscribe(onChange) {
        const handler = (event) => {
            onChange(event.detail);
        };
        this.eventTarget.addEventListener('change', handler);
        return () => this.eventTarget.removeEventListener('change', handler);
    }
    getItems() {
        return this.items;
    }
    getItem(id) {
        return this.items.find(t => t.id === id);
    }
    subscribeItem(id, onChange) {
        this.eventTarget.addEventListener(`change-${id}`, onChange);
        return () => this.eventTarget.removeEventListener(`change-${id}`, onChange);
    }
    clear() {
        const ids = this.items.map(t => t.id);
        this.items = [];
        ids.forEach(id => this.emitChange(id));
    }
    emitChange(id) {
        setTimeout(() => {
            if (id) {
                this.eventTarget.dispatchEvent(new CustomEvent(`change-${id}`, { detail: id }));
            }
            else {
                this.eventTarget.dispatchEvent(new Event('change'));
            }
        }, 10);
    }
    useItems() {
        return useSyncExternalStore(this.subscribe.bind(this), this.getItems.bind(this));
    }
    useItem(id) {
        return useSyncExternalStore(this.subscribeItem.bind(this, id), this.getItem.bind(this, id));
    }
}
